import { useEffect, useMemo, useState } from 'react';
const DEFAULT_TABLE_PAGE_SIZE = 100;
export const useTablePagination = function useTablePagination(items) {
    let pageSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_TABLE_PAGE_SIZE;
    const [page, setPage] = useState(1);
    useEffect(()=>{
        setPage(1);
    }, [
        items.length
    ]);
    const pagedItems = useMemo(()=>items.slice((page - 1) * pageSize, page * pageSize), [
        items,
        page,
        pageSize
    ]);
    return {
        pagedItems,
        pagination: {
            page,
            pageSize,
            total: items.length,
            onPageChange: setPage
        }
    };
};
